import EditorField from "../../Utils/EditorField"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
const DailyActivities = ({ formik }) => {
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <EditorField
          value={formik.values.daily_1}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.dailyActivities.dailyActivities_1.label}
          valueName={
            careerProfileLabels.dailyActivities.dailyActivities_1.value
          }
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <EditorField
          value={formik.values.daily_2}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.dailyActivities.dailyActivities_2.label}
          valueName={
            careerProfileLabels.dailyActivities.dailyActivities_2.value
          }
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <EditorField
          value={formik.values.daily_3}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.dailyActivities.dailyActivities_3.label}
          valueName={
            careerProfileLabels.dailyActivities.dailyActivities_3.value
          }
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <EditorField
          value={formik.values.daily_4}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.dailyActivities.dailyActivities_4.label}
          valueName={
            careerProfileLabels.dailyActivities.dailyActivities_4.value
          }
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <EditorField
          value={formik.values.daily_5}
          onTextChange={formik.setFieldValue}
          label={careerProfileLabels.dailyActivities.dailyActivities_5.label}
          valueName={
            careerProfileLabels.dailyActivities.dailyActivities_5.value
          }
        />
      </div>
    </>
  )
}
export default DailyActivities
